import '@slightlyoff/lite-vimeo';
import { createApp } from 'vue';
import HeaderComponent from './components/HeaderComponent.vue';
import CareerFilter from './components/CareerFilter.vue';

import GalleryApp from './components/GalleryApp.vue';
import GalleryGridApp from './components/GalleryGridApp.vue';



// Vue component
const App = {
    data() {
      return {
        message: 'Hello Vue 3!'
      };
    },
    components: {
        HeaderComponent,
        CareerFilter,
        GalleryApp,
        GalleryGridApp
    
    }
  };


// disable controlls on lite-vimeo
document.addEventListener('DOMContentLoaded', function () {
    // Mount Vue app
    const app = createApp(App);
    app.mount('#app');

    var contentBlocks = document.querySelectorAll('.content-block');
    if (contentBlocks) {
        // check if any of the contentBlocks children div  has a inline style , if so remove it
            contentBlocks.forEach(function (contentBlock) {
                var divs = contentBlock.querySelectorAll('div');
                if (divs) {
                    divs.forEach(function (div) {
                        if (div.hasAttribute('style')) {
                            div.removeAttribute('style');
                        }
                    });
                }
            }
        );
    }

    // Select the scroll trigger
    const scrollTrigger = document.querySelector('.scroll-trigger');
    if (scrollTrigger) {
        scrollTrigger.addEventListener('click', function () {
            // Find the parent banner container
            const banner = scrollTrigger.closest('.banner');
            if (banner) {
                // Find the next sibling after the banner
                let nextSection = banner.nextElementSibling;
                // Scroll the next section into view if it exists
                if (nextSection) {
                    nextSection.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    }

});
